{
  "name": "@cue/subclient",
  "type": "module",
  "version": "1.66.0",
  "private": true,
  "scripts": {
    "build": "nuxt build",
    "dev": "nuxt dev --port=3020",
    "preview": "nuxt preview",
    "postinstall": "nuxt prepare",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "test": "vitest run",
    "typecheck": "nuxt typecheck"
  },
  "dependencies": {
    "@cue/booking-lego": "workspace:^",
    "@cue/clue": "workspace:^",
    "@nuxtjs/robots": "^7.0.2",
    "@pinia/colada": "^1.4.9",
    "@pinia/colada-nuxt": "^1.2.1",
    "@pinia/nuxt": "^1.0.3",
    "@sentry/nuxt": "^11.10.0",
    "@vueuse/components": "^15.0.0",
    "@vueuse/core": "^15.0.0",
    "@vueuse/router": "^15.0.0",
    "date-fns": "^4.4.0",
    "date-fns-tz": "^3.2.0",
    "es-toolkit": "^1.53.1",
    "ics": "^3.12.1",
    "nuxt": "^4.6.4",
    "nuxt-site-config": "^5.0.3",
    "pinia": "^4.1.0",
    "pinia-plugin-persistedstate": "^4.7.1",
    "pug": "^3.0.4",
    "vue": "^3.5.44"
  },
  "devDependencies": {
    "@cue/eslint-config": "workspace:^",
    "@nuxt/test-utils": "^4.3.4",
    "@nuxtjs/i18n": "10.6.0",
    "@vue/test-utils": "^2.5.1",
    "eslint": "^10.14.0",
    "happy-dom": "^21.0.4",
    "nuxtseo-devtools-host": "^1.0.2",
    "typescript": "^6.0.3",
    "vitest": "^5.1.0",
    "vue-tsc": "^3.3.14"
  }
}
